<template>
  <!-- MOBILE ROW -->
  <div 
  v-if="vmode === 1"
  :class="['mrow elevation-0 pa-2', {'selected-row': selected[item.tempID]}]"
  v-ripple>

    <!-- MOBILE -->
    <v-layout v-if="$vuetify.breakpoint.smAndUp">
      <div class="c-flex-c mr-1">

        <v-btn
        icon
        @click.stop="$emit('checkRow', item)"
        class="ma-0">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
      </div>
      <v-flex>
        <span 
        class="font-weight-medium"
        v-html="highlightedName">
          
        </span>
        <div class="">
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalFilledDict[item.definitionId]"
          :key="definition.id + 'b'"
          alwaysScale
          labelMode
          ></c-metric-selector>
        </div>
        <v-progress-linear
        v-if="totalInStock > 0"
        class="ma-0"
        v-model="percent"
        :key="item.definitionId"
        background-color="hline"
        style="max-width: 200px;"
        :color="progressColor"
        height="5"
        ></v-progress-linear>
        <div v-else class="red--text">
          Out of stock
        </div>
        <v-layout 
        v-if="totalFilledDict[item.definitionId] > totalInStock"
        align-baseline class="text--text text--darken-1 caption">
          <span>
          Debit&nbsp;
          </span>
          <div>
            <c-metric-selector
            :inventoryItemID="definition.id" 
            :realValue="totalFilledDict[item.definitionId]"
            :key="definition.id + 'b'"
            alwaysScale
            labelMode
            ></c-metric-selector>
          </div>
          &nbsp;of&nbsp;
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalInStock"
          :key="definition.id + 'b'"
          alwaysScale
          labelMode
          ></c-metric-selector>          
        </v-layout>
        <div v-if="showRecipeErrors && required && (totalFilledDict[item.definitionId] !== required)"
        class="caption red--text">
          *
          Recipe requires
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="required"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          ></c-metric-selector>

          <v-chip v-if="required > totalFilled"
          color="red"
          text-color="white">
            short&nbsp;
            <c-metric-selector
            :inventoryItemID="definition.id" 
            :realValue="required - totalFilled"
            :key="definition.id + 'a'"
            alwaysScale
            labelMode
            class="text-sans"
            ></c-metric-selector>
          </v-chip>
          <v-chip v-if="required < totalFilled" color="red" text-color="white">
            over&nbsp;
            <c-metric-selector
            :inventoryItemID="definition.id" 
            :realValue="totalFilled - (required || 0)"
            :key="definition.id + 'a'"
            alwaysScale
            labelMode
            class="text-sans"
            ></c-metric-selector>
          </v-chip>
        </div>
        <!-- errors! -->
        <div v-if="showRecipeErrors && !required" class="red--text caption">
          *This item is not in the recipe
        </div>
        <div v-if="totalFilled > totalInStock" class="caption red--text">
          * Your trying to debit 
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalFilled"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
          but there is only 
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalInStock"
          :key="definition.id + 'b'"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
          available
        </div>

      </v-flex>
    </v-layout>


    <!-- PC -->
    <v-layout v-else-if="$vuetify.breakpoint.smAndUp">
      <v-flex xs4 class="table-flex-cell">
        <v-btn
        icon
        @click.stop="$emit('checkRow', item)"
        class="ma-0">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>

        <div class="subheading">
          {{ definition.name }}
          <v-chip v-if="batches.length > 1">
            {{ batches.length }}
          </v-chip>
        </div>
      </v-flex>
      <v-flex xs3 class="table-flex-cell">
        <v-layout column v-if="totalInStock > 0">
          <div>
            <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalFilledDict[item.definitionId]"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          class="text-sans subheading color1--text"
          ></c-metric-selector>
          /
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalInStock"
          :key="definition.id + 'b'"
          alwaysScale
          labelMode
          ></c-metric-selector>
          </div>
          <v-progress-linear
          class="ma-0 purple-gradient-progress"
          v-model="percent"
          background-color="transparent"
          height="5"
          :key="item.tempID"
          ></v-progress-linear>
          <!--
          <div
          class="caption">
            {{ percent.toFixed(2) }}%
          </div>
          -->
        </v-layout>
        <v-chip v-else color="red" text-color="white">
          Out of stock!
        </v-chip>
        <v-chip v-if="totalFilled > totalInStock" color="red" text-color="white">
          Short &nbsp;
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalFilled - totalInStock"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
        </v-chip>
      </v-flex>
      <v-flex xs3 class="table-flex-cell">
        <c-metric-selector
        :inventoryItemID="definition.id" 
        :realValue="required"
        :key="definition.id + 'a'"
        alwaysScale
        labelMode
        class="text-sans"
        ></c-metric-selector>
        <v-chip v-if="required > totalFilled" color="amber" text-color="white">
          - &nbsp;
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="required - totalFilled"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
        </v-chip>
        <v-chip v-if="required < totalFilled" color="amber" text-color="white">
          + &nbsp;
          <c-metric-selector
          :inventoryItemID="definition.id" 
          :realValue="totalFilled - required"
          :key="definition.id + 'a'"
          alwaysScale
          labelMode
          class="text-sans"
          ></c-metric-selector>
        </v-chip>
      </v-flex>
      <v-flex xs3 class="table-flex-cell">
        <c-metric-selector
        :inventoryItemID="definition.id" 
        :realValue="totalInStock - totalFilled"
        :key="definition.id + 'b'"
        alwaysScale
        labelMode
        ></c-metric-selector>
      </v-flex>
    </v-layout>

  </div>

</template>

<script>
export default {
  props: ['vmode', 'item', 'showRecipeErrors', 'inventoryView', 'selected', 'searchText', 'inputs', 'percent', 'required', 'totalInStock', 'totalFilledDict'],
  data () {
    return {
      totalDebit: 0
    }
  },
  computed: {
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.item.definitionId]
    },
    totalFilled () {
      return this.totalFilledDict[this.item.definitionId] || 0
    },
    batches () {
      return Object.values(this.inventoryView).filter(item => item.inventory_item_id === this.definition.id)
    },
    highlightedName () {
      if (!this.searchText) {
        return this.definition.name
      }
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.definition.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    },
    rowContainsRecipeError () {
      if (this.required !== this.totalFilled) {
        return true
      }
      if (this.totalFilled > this.required) {
        return true
      }
      return false
    },
    progressColor () {
      if (this.showRecipeErrors && this.rowContainsRecipeError) {
        return 'red'
      }
      return 'color1'
    }
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid #edeff2;
}
.mrow:hover {
  background: #fafbfc;
}
.selected-row {
  background: #f5f8fa;
}
.purple-gradient-progress {
  background: rgba(0,0,0,0.05);

  ::v-deep & .v-progress-linear__bar__determinate {
    background: var(--v-color1-base);
  }
}
.table-flex-cell {
  display: flex;
  align-items: center;
  padding: 0px 8px;
}
</style>
